import {useState} from "react";
import MobileTelCard from "../MobileTelCard";

const MobileBillSelect = ({bill, onSelect, parameter}) => {
    const [selected, setSelected] = useState(null);


    const handleChange = (e) => {
        setSelected(e.target.value);
        if (e.target.value === "Mobile") {

            onSelect(e.target.value, bill.Mobile)
        } else {

            onSelect(e.target.value, bill.MobileNow)
        }
    }
    return <div className="grid grid-cols-1  md:grid-cols-2 gap-3">
        <MobileTelCard bill={bill.Mobile} parameter={parameter} onChange={handleChange} type="Mobile" title="پایان دوره" selectedType={selected}/>
        <MobileTelCard bill={bill.MobileNow} parameter={parameter} onChange={handleChange} type="MobileNow" title="میان دوره" selectedType={selected}/>
        {/*<label className="block" htmlFor={"Mobile"}>
            <div
                className={`p-5 bg-white  cursor-pointer flex justify-between flex-col   rounded-xl ${selected === "Mobile" ? 'border-2 bg-green-100 border-green-500 ' : 'border-2 border-white'}`}>
                <div className="flex justify-between items-center">
                    <strong className="  w-full  ">پایان دوره</strong>
                    <span className="text-sm">{parameter}</span>
                </div>


                <div className={`w-full mt-2 py-2 border-t ${selected === "Mobile" ? "border-green-500" : ""}`}/>
                <div className="w-full flex text-sm items-center justify-between">

                    <div
                        className={`w-5 h-5 flex justify-center items-center bg-gray-200 rounded-full ${selected === "Mobile" && 'border-2 border-green-500'}`}>{
                        (selected === "Mobile") && <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
                    }</div>
                    <input hidden id={"Mobile"} value={"Mobile"} checked={selected === "Mobile"} onChange={handleChange}
                           name={"Mobile"} type="radio" className="radio"/>

                    <div className="flex justify-start">
                        <span className="ml-2">{bill.Mobile.Amount.faName} : </span>
                        <span>{formattedPrice.format(+bill.Mobile.Amount.value)}ریال</span>
                    </div>
                </div>
            </div>
        </label>*/}
       {/* <label className="block" htmlFor={"MobileNow"}>
            <div
                className={`p-5 bg-white  cursor-pointer flex justify-between flex-col   rounded-xl ${selected === "MobileNow" ? 'border-2 bg-green-100 border-green-500 ' : 'border-2 border-white'}`}>
                <div className="flex justify-between items-center"><strong className="  w-full  ">میان دوره</strong>
                    <span className="text-sm">{parameter}</span></div>
                <div className={`w-full mt-2 py-2 border-t ${selected === "MobileNow" ? "border-green-500" : ""}`}/>
                <div className="w-full flex text-sm items-center justify-between">
                    <div
                        className={`w-5 h-5 flex justify-center items-center bg-gray-200 rounded-full ${selected === "MobileNow" && 'border-2 border-green-500'}`}>{
                        (selected === "MobileNow") && <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
                    }</div>
                    <input hidden id={"MobileNow"} value={"MobileNow"} checked={selected === "MobileNow"}
                           onChange={handleChange} name={"MobileNow"} type="radio" className="radio"/>
                    <div className="flex justify-start">
                        <span className="ml-2">{bill.MobileNow.Amount.faName} : </span>
                        <span>{formattedPrice.format(+bill.MobileNow.Amount.value)}ریال</span>
                    </div>
                </div>
            </div>
        </label>*/}
    </div>
}
export default MobileBillSelect;